import styles from "./Button.styles.scss";
import {Body} from "../typography";

const Button = ({onClick, title, white, disabled}) => {
  return <button onClick={onClick} disabled={disabled} className={[styles.button, white && styles.buttonWhite].join(" ")}>
    <Body size="button" weight={600} className={[styles.text, (white && !disabled) && styles.textWhite].join(" ")}>{title}</Body>
  </button>;
};

export default Button;



// WEBPACK FOOTER //
// ./components/Button/Button.js